import * as XLSX from 'xlsx'

const EXTERNAL_ID_HEADERS = new Set([
  'externalid',
  'id',
  'orderid',
  'codebarre',
  'codebarres',
])

const normalizeHeader = value => String(value == null ? '' : value)
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]/g, '')

export const normalizeExternalId = value => String(value == null ? '' : value)
  .replace(/^\uFEFF/, '')
  .trim()
  .toLowerCase()

const findExternalIdColumn = rows => {
  for (let rowIndex = 0; rowIndex < Math.min(rows.length, 20); rowIndex += 1) {
    const row = Array.isArray(rows[rowIndex]) ? rows[rowIndex] : []
    const columnIndex = row.findIndex(value => EXTERNAL_ID_HEADERS.has(normalizeHeader(value)))
    if (columnIndex !== -1) {
      return {
        rowIndex,
        columnIndex,
        label: String(row[columnIndex] || 'external_id').trim(),
      }
    }
  }
  return null
}

export const parseExternalIdsFromRows = rows => {
  if (!Array.isArray(rows) || rows.length === 0) {
    throw new Error('Le fichier Excel est vide.')
  }

  const column = findExternalIdColumn(rows)
  if (!column) {
    throw new Error('Colonne external_id / id / Code Barres introuvable dans le fichier Excel.')
  }

  const identifiers = []
  const seen = new Set()
  rows.slice(column.rowIndex + 1).forEach(row => {
    const identifier = normalizeExternalId(Array.isArray(row) ? row[column.columnIndex] : '')
    if (identifier && !seen.has(identifier)) {
      seen.add(identifier)
      identifiers.push(identifier)
    }
  })

  return {
    identifiers,
    columnLabel: column.label,
    rowCount: identifiers.length,
  }
}

export const parseExternalIdsFromArrayBuffer = arrayBuffer => {
  const workbook = XLSX.read(arrayBuffer, {
    type: 'array',
    cellDates: false,
  })
  const firstSheetName = workbook.SheetNames && workbook.SheetNames[0]
  if (!firstSheetName) {
    throw new Error('Le fichier Excel ne contient aucune feuille.')
  }

  const rows = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheetName], {
    header: 1,
    // Read the underlying cell value. `raw: false` would return a display
    // value such as `2.60924E+13` for long numeric external IDs.
    raw: true,
    defval: '',
  })
  return parseExternalIdsFromRows(rows)
}
